import { CompanyRole } from "@/lib/miscellaneous/authorization";
import { UserQueryData } from "@/queries/users/types";
import {
  type ApolloError,
  type FetchResult,
  gql,
  useMutation,
} from "@apollo/client";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";




export const useUpdateCompanyUser = (): [
  (
    companyId: string,
    userId: string,
    role: CompanyRole,
  ) => Promise<FetchResult | undefined>,
  {
    data: UserQueryData | null | undefined;
    loading: boolean;
    error?: ApolloError;
  },
] => {
  const { t } = useTranslation();
  const [updateCompanyUser, { data, loading, error }] = useMutation<UserQueryData>(
    UPDATE_USER_COMPANY_ROLE,
  );

  const handleUpdateCompanyUser = async (
    companyId: string,
    userId: string,
    role: CompanyRole,
  ) => {
    const toastId = toast.loading(t("generic_loading"));

    try {
      const result = await updateCompanyUser({
        variables: { companyId, userId, role },
      });

      toast.success(t("generic_success"), { id: toastId });

      return result;
    } catch (error) {
      toast.error(t("generic_error"), { id: toastId, richColors: true });
    }
  };

  return [handleUpdateCompanyUser, { data, loading, error }];
};



export const UPDATE_USER_COMPANY_ROLE = gql`
  mutation UpdateUserCompanyRole($userId: String!, $companyId: String!, $role: String!) {
    updateUserCompanyRole(userId: $userId, companyId: $companyId, role: $role) {
      userId
      email
      name
      systemRole
      accountingFirms {
        accountingFirmId
        accountingFirmName
        role
      }
      companies {
        companyId
        companyName
        role
      }
    }
  }
`;